import React, { useSyncExternalStore } from 'react';

export type ModalRenderer = (context: { close: () => void }) => React.ReactNode;

let activeRender: ModalRenderer | null = null;
const listeners = new Set<() => void>();

function notify() {
  listeners.forEach(listener => listener());
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function getSnapshot() {
  return activeRender;
}

function getServerSnapshot() {
  return null;
}

export function openModalInstance(render: ModalRenderer) {
  activeRender = render;
  notify();
}

export function closeModalInstance() {
  activeRender = null;
  notify();
}

/**
 * Mount once in the app's root layout. `openModalInstance`/`closeModalInstance` update the
 * active renderer and this subscribes to it, so the dispatched modal renders
 * inside the existing tree
 */
export function ModalHost() {
  const render = useSyncExternalStore(
    subscribe,
    getSnapshot,
    getServerSnapshot
  );
  return render ? render({ close: closeModalInstance }) : null;
}
